export const TRANSFORMER_PACKAGE_MAP = {
  reg_minimum_v1: 'ライトパッケージ',
  reg_normal_v1: '旧パッケージ',
  reg_normal_v2: 'スタンダードパッケージ',
  reg_advanced_v1: 'アドバンストパッケージ',
  clf_minimum_v1: 'ライトパッケージ',
  clf_normal_v1: '旧パッケージ',
  clf_normal_v2: 'スタンダードパッケージ',
  clf_advanced_v1: 'アドバンストパッケージ',
  tsa_normal_v1: 'スタンダードパッケージ'
}



// WEBPACK FOOTER //
// ./src/defines/model/transformer-package.js